export default __webpack_public_path__ + "static/media/project_bullground_7.41baaa1e.png";